import { DomainTypeGq } from './DomainTypeGq';

export interface DomainGq {
  id: number;
  parentProjectId: number;
  hostName: string;
  protocol: string;
  type: DomainTypeGq;
  name: string;
  insertCompleted: boolean;
  scrapeTriggered: boolean;
  automaticDomainOrder?: number;
}

export const DomainGqProps = `
  id
  parentProjectId
  name
  hostName
  protocol
  type
  insertCompleted
  automaticDomainOrder
  scrapeTriggered
`;
